var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M395.511,261.354c0,0-4.219-16.875-16.875-25.313c0,0,12.656,21.094,12.656,37.969L395.511,261.354z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M375.999,243.028c0,0,8.833,5.405,13.579,14.238l-3.823,8.833   C385.755,266.1,382.591,253.575,375.999,243.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M366.243,245.006c0,0,15.293,4.746,22.544,14.634l-4.351,6.592   C384.437,266.232,378.636,255.025,366.243,245.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M364.002,252.652c0,0,16.084,2.505,23.335,10.152l-1.846,7.251   C385.492,270.055,376.659,259.508,364.002,252.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M364.529,257.926c0,0,15.557,1.582,22.676,9.756s-2.637,5.669-2.637,5.669   S376.395,263.99,364.529,257.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M395.511,261.354c0,0,4.219-16.875,16.875-25.313c0,0-12.656,21.094-12.656,37.969L395.511,261.354z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M415.023,243.028c0,0-8.833,5.405-13.579,14.238l3.823,8.833   C405.267,266.1,408.431,253.575,415.023,243.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M424.779,245.006c0,0-15.293,4.746-22.544,14.634l4.351,6.592   C406.586,266.232,412.387,255.025,424.779,245.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M427.021,252.652c0,0-16.084,2.505-23.335,10.152l1.846,7.251   C405.531,270.055,414.364,259.508,427.021,252.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M426.493,257.926c0,0-15.557,1.582-22.676,9.756s2.637,5.669,2.637,5.669   S414.628,263.99,426.493,257.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M395.511,236.041c0,0-4.219,8.877,0,13.316C399.73,244.918,395.511,236.041,395.511,236.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M391.309,238.244c0,0-0.566,9.812,5.013,12.336C398.559,244.88,391.309,238.244,391.309,238.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M399.714,238.244c0,0,0.566,9.812-5.013,12.336C392.464,244.88,399.714,238.244,399.714,238.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M401.096,243.904c0,0-3.681,9.113-9.804,9.011C391.705,246.805,401.096,243.904,401.096,243.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M389.927,243.904c0,0,3.681,9.113,9.804,9.011C399.317,246.805,389.927,243.904,389.927,243.904z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD255"
    },
    cx: 395.51,
    cy: 265.57,
    rx: 12.656,
    ry: 16.875
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M366.595,282.799l-2.9-4.482c0,0-8.438,2.022-10.459-4.307l-3.252-0.264   c0,0,0.439-4.307,4.219-4.922c0,0,2.285-2.813,6.328-2.285c4.043,0.527,6.152,3.955,8.482,4.834   c2.329,0.879,2.593,3.779,2.593,3.779l17.754,18.194c0,0-5.098,6.504-9.668,8.613C375.12,304.069,358.333,293.786,366.595,282.799z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M424.252,286.139c0,0,7.383,5.01,7.647,18.853h-12.261c0,0,0.132-9.36-2.241-14.37L424.252,286.139z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M422.67,286.666c0,0,9.229,3.032,14.898-4.219l-9.624-1.318L422.67,286.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M419.901,276.515l9.371,3.159c1.182,0.398,1.599,1.861,0.771,2.794   c-3.555,4.005-14.168,13.603-31.279,13.603c-22.281,0-28.038-14.019-28.301-15.073c-0.264-1.055-1.45-9.624-1.45-9.624l9.492-1.055   L419.901,276.515z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "328.784,405.591 353.323,405.591 340.667,430.106 328.01,413.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "462.239,405.591 437.699,405.591 450.356,430.106 463.012,413.231  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD25A"
    },
    d: "M328.682,446.981c-12.106,0-21.37-6.497-21.848-6.835l9.756-13.773   c0.08,0.054,8.254,5.607,16.589,3.082c8.434-2.546,13.971-12.5,17.133-20.406l15.668,6.271   c-6.648,16.62-16.127,26.833-28.172,30.364C334.658,446.606,331.586,446.981,328.682,446.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD25A"
    },
    d: "M462.341,446.981c12.106,0,21.37-6.497,21.848-6.835l-9.756-13.773   c-0.08,0.054-8.254,5.607-16.589,3.082c-8.434-2.546-13.971-12.5-17.133-20.406l-15.668,6.271   c6.647,16.62,16.127,26.833,28.172,30.364C456.365,446.606,459.436,446.981,462.341,446.981z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M450.356,358.386H340.667V315.76c0-4.418,3.582-8,8-8h93.689c4.418,0,8,3.582,8,8V358.386z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M370.594,337.292l-1.318-8.438c-6.196-0.264-9.756-7.515-9.756-7.515l-5.01,2.769   C359.783,336.765,370.594,337.292,370.594,337.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M436.645,328.591c1.846-1.406,5.889-1.934,5.889-1.934c-2.9-2.988-6.065-0.879-6.065-0.879   c2.637-2.461,1.143-5.976,1.143-5.976c0,1.143-1.846,1.934-1.846,1.934c0.088-2.286-2.285-4.482-2.285-4.482l-1.231,2.021   c-0.791-1.934-3.603-3.428-3.603-3.428l-1.143,4.746c-2.637-2.285-7.295-2.109-7.295-2.109l0.879,2.197   c-2.813,0.088-10.459,1.67-14.942,2.197s-8.086-0.703-8.086-2.724c0-1.693,3.918-1.903,5.612-1.928   c1.199,0.267,2.707,0.699,4.825,1.335c3.955,1.187,6.272-0.532,6.272-0.532c-1.384-0.527-1.539-1.142-1.539-1.142   c2.966-1.714,5.748-1.292,5.748-1.292c-0.989-2.175-5.273-2.043-5.273-2.043c1.121-0.593,1.978-2.439,1.978-2.439   c-0.264,0.264-2.7,0.861-6.026,1.308c-2.503,0.336-4.854,2.24-5.825,3.119c-2.639-0.201-9.534-0.286-8.321,4.494   c1.494,5.889,13.36,3.78,20.655,2.637c7.295-1.142,11.074-0.176,12.656,0.791c1.582,0.967-0.674,4.242-8.086,2.9   c-6.406-1.159-9.933-1.192-11.87-0.989c-2.147,0.138-3.979,0.715-5.269,0.989c-2.9,0.615-14.063,4.571-16.172-1.142   s-12.393,9.316-12.393,9.316l0.803,0.956l-2.737-0.648c-3.691,4.944-14.766,6.46-14.766,6.46s-1.648-2.966-3.032-3.362   s-1.978,1.78-1.978,1.78s-1.648,0.066-1.78,1.582s1.187,1.648,1.187,1.648s-1.582,2.307,1.055,2.966c0,0-0.198,3.23,3.691,0.989   c11.553,1.456,19.979-4.477,23.627-7.712c2.384,0.152,6.101,0.077,8.959-1.406c4.571-2.373,9.844-5.362,12.92-4.219   c0,0,2.461,7.559-7.207,7.735c0,0-1.43-1.809-2.87-1.809c-0.621,0-1.266,0.745-1.067,1.415c0,0-1.687-0.099-1.985,0.894   c-0.243,0.81,0.347,1.737,1.588,1.588c0,0-0.844,1.241,0,1.985s1.886,0,1.886,0s-0.447,1.538,0.596,1.688   c0.892,0.127,2.072-1.329,2.41-1.772c1.547,0.24,12.104,1.458,14.383-9.614c0,0,5.273,2.285,10.459,1.846   c5.186-0.439,10.283,0.352,9.844,2.9c-0.575,1.847-1.708,1.726-1.708,1.726c-1.241-0.496-3.326-0.447-3.623,1.34   c-0.298,1.787,2.134,1.836,2.134,1.836c0.695,1.638,2.68,0.943,2.68,0.943c1.737,1.241,2.879-0.099,2.879-0.099   c0.745,0.645,1.514,0.766,2.234,0.149c0.695-0.595,0.305-4.566,0.239-5.983c-0.11-2.358-0.44-8.525-3.867-8.613   c-3.428-0.088-7.822,1.934-13.887-3.164c-0.317-0.266-0.625-0.435-0.939-0.662c2.87,0.266,4.926,1.044,6.915,1.365   C426.801,330.7,434.799,329.997,436.645,328.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M354.51,324.108c0,0-1.681,0.045-2.505-0.198c-1.411-0.416-1.582-2.637-0.066-3.032   c0,0-1.825-1.24-0.989-2.637c0.669-1.117,2.375-1.114,2.969-0.455c0,0-0.556-1.838,1.052-2.445c1.28-0.483,2.307,0.989,2.307,2.9   c0,0,1.913-1.556,2.9-0.527c0.689,0.717,0.49,1.66-0.659,3.626C358.347,323.344,354.51,324.108,354.51,324.108z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M352.43,323.296c0,0-0.893,1.539-3.474,0.596c0,0,2.233-1.042,2.531-1.936L352.43,323.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M351.487,318.779c0,0-1.39-0.893-2.928-0.844c0,0,2.283-1.688,4.219-0.199L351.487,318.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M354.713,316.397c0,0,0.447-1.638-0.447-2.531c0,0,1.836,0.794,2.085,2.283L354.713,316.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M358.783,318.084c0,0,0.893-1.985,0.099-2.928c0,0,2.382,1.39,1.39,3.673L358.783,318.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M354.133,340.143c0,0-0.955-1.956-2.188-1.948c0,0,2.592-0.943,3.713,1.28L354.133,340.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M352.044,342.633c0,0-1.704-1.355-2.814-0.818c0,0,1.934-1.966,3.902-0.442L352.044,342.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M353.241,346.15c0,0-2.177-0.025-2.724,1.081c0,0,0.321-2.739,2.81-2.743L353.241,346.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M355.23,348.411c0,0-0.893,1.539-3.474,0.596c0,0,2.233-1.042,2.531-1.936L355.23,348.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M394.461,347.629c0,0-0.732,1.26-2.846,0.488c0,0,1.716-0.613,1.96-1.345L394.461,347.629z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD255"
    },
    d: "M372.134,320.417c0,0-4.748,8.086-3.606,19.776c0,0,13.997-2.043,20.061-16.018  c0,0,1.478-0.597,2.054-2.032c0.49-1.221,0.45-3.23-1.901-3.219c0,0,0.703-1.406,1.56-1.736c0,0-1.516-0.593-3.296-0.198  c0,0,1.384-1.384,1.384-3.164c0,0-2.109,1.384-3.428,1.516c0,0-0.132-2.175,0.396-2.439c0,0-2.769,0.264-4.153,1.714  c0,0-0.923-1.252-0.857-2.571c0,0-2.571,1.121-3.56,2.769c0,0-0.791-0.857-0.725-1.714c0,0-1.846,2.241-2.241,3.428  c0,0-1.739-0.478-2.505,0.923C370.767,318.461,370.893,319.573,372.134,320.417z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M392.351,341.743c0,0-0.563-1.059-2.25-1.29c0,0,2.151-0.993,3.507,0.43L392.351,341.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M427.244,345.763c0,0-1.234,0.389-1.81,2.134c0,0-0.631-2.476,1.144-3.637L427.244,345.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M429.833,346.673c0,0-1.168,1.135-1.112,2.972c0,0-1.441-2.11-0.171-3.809L429.833,346.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M435.416,346.574c0,0-0.353,1.202,0.714,2.484c0,0-2.21-0.703-2.25-2.627L435.416,346.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M432.792,347.041c0,0-0.937,0.891-0.689,2.712c0,0-1.743-1.531-0.657-3.353L432.792,347.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M390.553,343.91c0,0-1.129-0.404-2.533,0.56c0,0,0.922-2.182,2.883-2.043L390.553,343.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M392.095,346.311c0,0-1.16-0.304-2.474,0.78c0,0,0.202-2.105,2.168-2.138L392.095,346.311z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M450.356,365.185c-9.149,0-9.149,8.253-18.298,8.253s-9.149-8.253-18.298-8.253  c-9.143,0-9.143,8.253-18.285,8.253c-9.135,0-9.135-8.253-18.269-8.253c-9.133,0-9.133,8.253-18.267,8.253  c-9.136,0-9.136-8.253-18.272-8.253v-15.236c9.136,0,9.136,8.253,18.272,8.253c9.133,0,9.133-8.253,18.267-8.253  c9.135,0,9.135,8.253,18.269,8.253c9.143,0,9.143-8.253,18.285-8.253c9.149,0,9.149,8.253,18.298,8.253s9.149-8.253,18.298-8.253  V365.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M432.058,373.437c-9.149,0-9.149-8.253-18.298-8.253c-9.143,0-9.143,8.253-18.285,8.253  c-9.135,0-9.135-8.253-18.269-8.253c-9.133,0-9.133,8.253-18.267,8.253c-9.117,0-9.143-8.212-18.221-8.247  c0.127,3.648,0.545,9.063,1.615,15.425c7.421,0.983,8.098,8.059,16.607,8.059c9.133,0,9.133-8.253,18.267-8.253  c9.135,0,9.135,8.253,18.269,8.253c9.143,0,9.143-8.253,18.285-8.253c9.149,0,9.149,8.253,18.298,8.253  c8.522,0,9.199-7.077,16.633-8.059c1.07-6.362,1.488-11.777,1.615-15.425C441.213,365.225,441.188,373.437,432.058,373.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M432.058,388.674c-9.149,0-9.149-8.253-18.298-8.253c-9.143,0-9.143,8.253-18.285,8.253  c-9.135,0-9.135-8.253-18.269-8.253c-9.133,0-9.133,8.253-18.267,8.253c-8.509,0-9.186-7.076-16.607-8.059  c0.848,5.041,2.113,10.663,3.977,16.477c4.113,2.36,5.905,6.817,12.63,6.817c9.133,0,9.133-8.253,18.267-8.253  c9.135,0,9.135,8.253,18.269,8.253c9.143,0,9.143-8.253,18.285-8.253c9.149,0,9.149,8.253,18.298,8.253  c6.741,0,8.532-4.465,12.658-6.824c1.863-5.811,3.127-11.431,3.974-16.47C441.257,381.597,440.58,388.674,432.058,388.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M432.058,403.909c-9.149,0-9.149-8.253-18.298-8.253c-9.143,0-9.143,8.253-18.285,8.253  c-9.135,0-9.135-8.253-18.269-8.253c-9.133,0-9.133,8.253-18.267,8.253c-6.726,0-8.517-4.457-12.63-6.817  c2.322,7.243,5.581,14.755,10.133,21.761c0.767,0.157,1.557,0.293,2.498,0.293c9.133,0,9.133-8.253,18.267-8.253  c9.135,0,9.135,8.253,18.269,8.253c9.143,0,9.143-8.253,18.285-8.253c9.149,0,9.149,8.253,18.298,8.253  c0.951,0,1.751-0.135,2.525-0.295c4.552-7.008,7.811-14.521,10.133-21.765C440.59,399.444,438.799,403.909,432.058,403.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M432.058,419.146c-9.149,0-9.149-8.253-18.298-8.253c-9.143,0-9.143,8.253-18.285,8.253  c-9.135,0-9.135-8.253-18.269-8.253c-9.133,0-9.133,8.253-18.267,8.253c-0.94,0-1.731-0.135-2.498-0.293  c2.892,4.452,6.316,8.685,10.347,12.515c2.794-2.36,5.012-5.24,10.418-5.24c9.135,0,9.135,8.253,18.269,8.253  c9.143,0,9.143-8.253,18.285-8.253c5.428,0,7.647,2.894,10.456,5.257c4.04-3.836,7.47-8.076,10.367-12.535  C433.809,419.01,433.009,419.146,432.058,419.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M424.216,431.386c-2.808-2.363-5.028-5.257-10.456-5.257c-9.143,0-9.143,8.253-18.285,8.253  c-9.135,0-9.135-8.253-18.269-8.253c-5.406,0-7.624,2.88-10.418,5.24c7.348,6.983,16.718,12.611,28.723,15.612  C407.507,443.982,416.87,438.361,424.216,431.386z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M413.76,349.949c-9.143,0-9.143,8.253-18.285,8.253c-9.135,0-9.135-8.253-18.269-8.253   c-9.133,0-9.133,8.253-18.267,8.253c-9.136,0-9.136-8.253-18.272-8.253c0,5.205,0,9.727,0,12.656c0,0.714,0.016,1.593,0.051,2.585   c9.079,0.035,9.104,8.247,18.221,8.247c9.133,0,9.133-8.253,18.267-8.253c9.135,0,9.135,8.253,18.269,8.253   c9.143,0,9.143-8.253,18.285-8.253c9.149,0,9.149,8.253,18.298,8.253c9.13,0,9.156-8.212,18.247-8.247   c0.034-0.992,0.051-1.871,0.051-2.585c0-2.93,0-7.451,0-12.656c-9.149,0-9.149,8.253-18.298,8.253   C422.909,358.201,422.909,349.949,413.76,349.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M446.137,307.761c2.33,0,4.219,1.889,4.219,4.219v37.969v8.438c0,1.599,0,3.061,0,4.219   c0,0.714-0.016,1.593-0.051,2.585c-0.127,3.648-0.545,9.063-1.615,15.425c-0.848,5.039-2.112,10.659-3.974,16.47   c-2.322,7.244-5.581,14.758-10.133,21.765c-2.897,4.46-6.327,8.7-10.367,12.535c-7.346,6.975-16.709,12.596-28.705,15.595   c-12.005-3.001-21.375-8.63-28.723-15.612c-4.031-3.831-7.455-8.064-10.347-12.515c-4.551-7.006-7.811-14.518-10.133-21.761   c-1.864-5.814-3.129-11.436-3.977-16.477c-1.07-6.362-1.488-11.777-1.615-15.425c-0.034-0.992-0.051-1.871-0.051-2.585   c0-1.158,0-2.62,0-4.219v-8.438V311.98c0-2.33,1.889-4.219,4.219-4.219L446.137,307.761 M446.137,304.596H344.886   c-4.071,0-7.383,3.312-7.383,7.383v37.969v8.438v4.219c0,0.744,0.017,1.661,0.053,2.694c0.119,3.444,0.504,8.987,1.656,15.841   c0.981,5.835,2.355,11.527,4.084,16.918c2.674,8.342,6.205,15.918,10.492,22.518c3.158,4.861,6.798,9.263,10.82,13.085   c8.391,7.973,18.53,13.487,30.135,16.389l0.767,0.192l0.767-0.192c11.597-2.899,21.73-8.407,30.116-16.371   c4.032-3.828,7.68-8.237,10.842-13.106c4.288-6.602,7.819-14.18,10.493-22.523c1.727-5.387,3.1-11.077,4.082-16.911   c1.152-6.854,1.537-12.397,1.656-15.84c0.036-1.034,0.053-1.951,0.053-2.695v-4.219v-8.438v-37.969   C453.52,307.908,450.208,304.596,446.137,304.596L446.137,304.596z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "395.511,421.468 383.934,429.523 388.019,416.023 376.781,407.504 390.88,407.217   395.511,393.894 400.143,407.217 414.242,407.504 403.004,416.023 407.088,429.523 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M395.511,396.498l4.018,11.561l12.237,0.25l-9.753,7.394l3.544,11.715l-10.046-6.991l-10.046,6.991  l3.544-11.715l-9.753-7.394l12.237-0.25L395.511,396.498 M395.511,391.293l-1.614,4.644l-3.628,10.437l-11.048,0.225l-4.916,0.1  l3.918,2.971l8.805,6.676l-3.2,10.576l-1.424,4.706l4.036-2.809l9.07-6.311l9.07,6.311l4.036,2.809l-1.424-4.706l-3.2-10.576  l8.805-6.676l3.918-2.971l-4.916-0.1l-11.048-0.225l-3.628-10.437L395.511,391.293L395.511,391.293z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "370.086,388.562 358.509,396.617 362.594,383.117 351.356,374.598 365.455,374.311   370.086,360.988 374.718,374.311 388.817,374.598 377.579,383.117 381.663,396.617 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M370.086,363.592l4.018,11.561l12.237,0.25l-9.753,7.394l3.544,11.715l-10.046-6.991l-10.046,6.991  l3.544-11.715l-9.753-7.394l12.237-0.25L370.086,363.592 M370.086,358.386l-1.614,4.644l-3.628,10.437l-11.048,0.225l-4.916,0.1  l3.918,2.971l8.805,6.676l-3.2,10.576l-1.424,4.706l4.036-2.809l9.07-6.311l9.07,6.311l4.036,2.809l-1.424-4.706l-3.2-10.576  l8.805-6.676l3.918-2.971l-4.916-0.1l-11.048-0.225l-3.628-10.437L370.086,358.386L370.086,358.386z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "420.712,388.562 409.135,396.617 413.22,383.117 401.981,374.598 416.08,374.311   420.712,360.988 425.344,374.311 439.443,374.598 428.205,383.117 432.289,396.617 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M420.712,363.592l4.018,11.561l12.237,0.25l-9.753,7.394l3.544,11.715l-10.046-6.991l-10.046,6.991   l3.544-11.715l-9.753-7.394l12.237-0.25L420.712,363.592 M420.712,358.386l-1.614,4.644l-3.628,10.437l-11.048,0.225l-4.916,0.1   l3.918,2.971l8.805,6.676l-3.2,10.576l-1.424,4.706l4.036-2.809l9.07-6.311l9.07,6.311l4.036,2.809l-1.424-4.706l-3.2-10.576   l8.805-6.676l3.918-2.971l-4.916-0.1l-11.048-0.225l-3.628-10.437L420.712,358.386L420.712,358.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M462.239,405.591c-10.47,26.658-36.399,45.609-66.727,45.609s-56.258-18.951-66.727-45.609   l-15.7,6.143c12.933,32.93,44.964,56.341,82.427,56.341s69.494-23.411,82.427-56.341L462.239,405.591z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "403.949,307.761 391.293,307.761 387.074,295.104 399.73,295.104  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M425.043,307.761h-8.438l-2.813-8.438h3.851c2.739,0,5.171,1.753,6.037,4.351L425.043,307.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M378.636,307.761h-8.438l-0.962-2.885c-0.911-2.732,1.123-5.553,4.002-5.553h2.584L378.636,307.761z   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M416.605,307.761h-12.656l-4.219-12.656h9.616c1.816,0,3.428,1.162,4.002,2.885L416.605,307.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M391.293,307.761h-12.656l-2.85-8.549c-0.674-2.021,0.83-4.107,2.96-4.107h8.327L391.293,307.761z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#509664"
    },
    d: "M426.493,278.493c-3.296,4.746-12.525,10.415-27.554,10.415c-12.384,0-20.349-7.478-23.008-10.426  c-0.648-0.718-0.986-1.635-0.986-2.602v-2.877c0-1.238,0.642-2.365,1.713-2.988c2.679-1.558,8.871-4.046,21.095-4.046  C412.914,265.968,426.493,278.493,426.493,278.493z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0.046 0,0.046 0,20.023 94.316,81.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.345 0,94.362 39.71,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.73 0,187.747 39.71,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,20.023 256,0.046 161.684,0.046 161.684,81.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.747 256,161.73 216.29,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.276 161.684,256.046 256,256.046 256,236.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.362 256,68.345 216.29,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.069 0,256.046 94.316,256.046 94.316,174.276  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.069 256,216.105 172.232,161.73 196.98,161.73 256,200.041 256,187.747    216.29,161.73 256,161.73 256,148.256 148.211,148.256 148.211,256.046 161.684,256.046 161.684,174.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.256 0,161.73 39.71,161.73 0,187.747 0,206.648 69.197,161.73 93.945,161.73    0,222.712 0,236.069 94.316,174.276 94.316,256.046 107.789,256.046 107.789,148.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0.046 94.316,0.046 94.316,81.816 0,20.023 0,41.885 80.842,94.362 56.094,94.362    0,57.95 0,68.345 39.71,94.362 0,94.362 0,107.836 107.789,107.836  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.836 256,94.362 216.29,94.362 256,68.345 256,49.203 186.432,94.362    161.684,94.362 256,33.139 256,20.023 161.684,81.816 161.684,0.046 148.211,0.046 148.211,107.836  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.256 256,107.836 148.211,107.836 148.211,0.046 107.789,0.046 107.789,107.836    0,107.836 0,148.256 107.789,148.256 107.789,256.046 148.211,256.046 148.211,148.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.73 0,206.648 0,222.712 93.945,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.73 256,216.105 256,200.041 196.98,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.362 0,41.885 0,57.95 56.094,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.362 256,49.203 256,33.139 161.684,94.362  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKy);
export default __webpack_public_path__ + "static/media/KY.27c3e2996dbdc5c811033c1a8bb81055.svg";
export { ForwardRef as ReactComponent };